
import { Input, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { postApi } from '../../redux/rest/restSlice';
import get from 'lodash/get';
import { generatePaginationObj, getNextSort, TABLE_PAGINATION } from '../../utilities/helper';
import { unwrapResult } from '@reduxjs/toolkit';
import { LIST_CUSTOMER } from '../../constants/actionTypes';
import { customerTable } from '../../constants/customer';
import DataTable from '../DataTable';

import React, { useEffect, useState } from 'react';


const CustomerTable = () => {
    const [loading, setLoading] = useState(true);
    const [emailSearch, setEmailSearch] = useState('');
    const [customerData, setCustomerData] = useState({
        data: null,
        filters: {},
        sort: null,
        pagination: {
            offset: 0,
            limit: 10,
            total: 0,
            current: 1,
        },
    });

    const dispatch = useDispatch();

    const fetchCustomerList = (page=1, filters={}, sort=null, limit=get(customerData, 'pagination.limit')) => {
        setLoading(true);
        const pageObj = generatePaginationObj(page, limit)

        dispatch(postApi({
            endpoint: LIST_CUSTOMER,
            payload: {
                filters: {...filters},
                ...pageObj,
                ...(sort ? { sortBy: sort.sortBy, sortDir: sort.sortDir } : {}),
            },
        }))
            .then(unwrapResult)
            .then((result) => {
                setLoading(false);
                setCustomerData({
                    data: get(result, 'data'),
                    filters,
                    sort,
                    pagination: {
                        ...pageObj,
                        total: get(result, "total"),
                        current: page,
                    },
                },);
            })
            .catch((error) => {
                setLoading(false);
            })
    };

    useEffect(() => {
        fetchCustomerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onSearchEmail = (value) => {
        const term = (value || '').trim();
        const { email_address, ...rest } = get(customerData, 'filters', {});

        fetchCustomerList(
            1,
            term ? { ...rest, email_address: term } : rest,
            get(customerData, 'sort'),
        );
    };

    const clearSearch = () => {
        setEmailSearch('');
        onSearchEmail('');
    };

    const onTableChange = (paginationObj, _filters, sorter, extra) => {
        if (get(extra, 'action') === 'sort') {
            // First Name / Last Name / Created At
            fetchCustomerList(1, get(customerData, 'filters'), getNextSort(sorter, get(customerData, 'sort')));
            return;
        }

        // Page change, or page size change (back to page 1)
        const pageSize = get(paginationObj, 'pageSize');
        const sizeChanged = pageSize !== get(customerData, 'pagination.limit');

        fetchCustomerList(
            sizeChanged ? 1 : get(paginationObj, 'current'),
            get(customerData, 'filters'),
            get(customerData, 'sort'),
            pageSize,
        );
    };

    const rows = get(customerData, 'data');
    const firstLoad = loading && !(rows && rows.length);

    return (
        <Spin spinning={loading && !firstLoad}>
            <div className='list-toolbar'>
                <div className='list-toolbar__main'>
                    <Input.Search
                        className='list-toolbar__search'
                        placeholder='Search by Email Address'
                        allowClear
                        value={emailSearch}
                        onChange={(e) => setEmailSearch(e.target.value)}
                        onSearch={onSearchEmail}
                    />
                </div>
            </div>

            <DataTable
                skeleton={firstLoad}
                scrollX={800}
                rowKey='id'
                className='mt-20'
                dataSource={rows}
                columns={customerTable(
                    get(customerData, 'pagination.offset'),
                    get(customerData, 'sort'),
                )}
                pagination={{
                    ...TABLE_PAGINATION,
                    pageSize: get(customerData, 'pagination.limit'),
                    total: get(customerData, 'pagination.total'),
                    current: get(customerData, 'pagination.current'),
                }}
                onChange={onTableChange}
                emptyProps={{
                    noun: 'customers',
                    search: get(customerData, 'filters.email_address'),
                    onClearSearch: clearSearch,
                }}
            />
        </Spin>
    );
};

export default CustomerTable;
